import React from "react";
import {
    Breadcrumb, Layout
} from "antd";

import Nav from "../components/Nav";
import HeaderJs from "../components/HeaderJs";
import FooterJs from "../components/FooterJs";

const { Header, Content } = Layout;

// CompareContracts component for displaying the compare contracts page
// It includes a navigation sidebar, header, footer, and a content area with a placeholder message
const CompareContracts = () => {

    return (
        <div className="SCAUX">
            <Layout>
                <Header className="header" >
                    <HeaderJs />
                </Header>
                <Layout>
                    <Nav />
                    <Content >
                        <div className="content">
                            <div id="scrollableDiv" className="scrollable-content">
                                <div className="searchfilter">
                                    <Breadcrumb
                                        className="page-title"
                                    >
                                        <Breadcrumb.Item>
                                            <span className="page-title-label">Compare Contracts</span>
                                        </Breadcrumb.Item>
                                    </Breadcrumb>
                                </div>
                                <div style={{ alignItems: "center", margin: "40vh 85vh" }}>
                                    <h2>Coming Soon</h2>
                                </div>
                            </div>
                        </div>
                    </Content>
                </Layout>
                <FooterJs />
            </Layout>
        </div>
    );
}

export default CompareContracts;